const arrayLoop = (items, callback) => {
	const revItems = items.slice().reverse(); // reverse array first cause we're using reverse loop
	for (let i = revItems.length; i--;) {
		callback(revItems[i], revItems.length - (i + 1));
	}
};

export default arrayLoop;

